import React from 'react';
import { Navigation } from '../components/Navigation';
import { About } from '../components/About';
import { Footer } from '../components/Footer';

export const AboutPage = () => {
  return (
    <div className="page-transition">
      <Navigation />
      <About />
      <Footer />
    </div>
  );
};
